import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import I18n from "../i18n.js.jsx";
import PercentFormatter from "../../utils/percent_formatter.js.jsx";

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grayBg,
    display: "flex",
    padding: "16px 0",
    fontWeight: theme.typography.fontWeightMedium,
    ['@media (max-width: 768px)']: {
      padding: "8px 0",
    },
  },
  value: {
    fontSize: "28px",
    lineHeight: "1.3",
    margin: "0 0 12px",
    ['@media (max-width: 768px)']: {
      fontSize: "17px",
      lineHeight: "22px",
      margin: "0 0 5px",
    },
  },
  label: {
    fontSize: "18px",
    lineHeight: "1.3",
    margin: "0",
    ['@media (max-width: 768px)']: {
      fontSize: "11px",
      lineHeight: "16px",
    },
  }
}));

/**
 * Display info of project about period and revenue
 * @name BonusRatesBlock
 * @param {object} props React component properties
 * @param {string} [props.className] CSS-class of container
 * @param {object} [props.project] Project info from API
 * @example
 * const project = projects[0];
 * return (
 *  <RevenueAndPeriodBlock className = { "class-name" }
 *                         project = { project } />
 * )
*/

const BonusRatesBlock =  (props) => {

  const classes = blockStyles();
  const { className, project = {} } = props;
  const { bonusRates } = project;
  if(bonusRates.length == 0) {
    return (null);
  }
  return (
    <div className = { clsx(classes.root, className) } >
      <h4 className = { classes.title } > { ProjectModel.fieldDisplayName("bonus_rates") }</h4>
      {
        bonusRates.map(bonus_rate => {
          return <React.Fragment>
            <div className = { classes.value } >
              { PercentFormatter.format(bonus_rate.rate / 100, "0.00 %") }
            </div>
            <div className = { classes.label } >
              { I18n.t("shared.revenue") }
            </div>
          </React.Fragment>
        })
      }
    </div>
  );
}

export default BonusRatesBlock;
